import { SearchParamKey } from '@app/shared/models/search-param-enum';
import { SponsorIrrAndHurdleTab } from '@app/shared/models/contracts/enums/shared-enums';
import { FocusSelections } from './focus-mode-types';

export function buildFocusModeSearchParams(selections: FocusSelections): string {
  const params = new URLSearchParams();

  params.set(SearchParamKey.FocusType, selections.type);

  if (selections.type === SponsorIrrAndHurdleTab.SponsorIRR) {
    params.set(SearchParamKey.FocusCase, selections.case);
    params.set(SearchParamKey.FocusYear, selections.year);
    params.set(SearchParamKey.FocusMultiple, selections.multiple);
    return params.toString();
  }

  if (selections.case) {
    params.set(SearchParamKey.FocusCase, selections.case);
  }
  params.set(SearchParamKey.FocusYear, selections.year);
  params.set(SearchParamKey.FocusInstrument, selections.instrument);
  params.set(SearchParamKey.FocusHurdle, selections.hurdle);
  params.set(SearchParamKey.FocusHurdleTitle, selections.hurdleTitle);
  params.set(SearchParamKey.FocusSource, selections.source);

  return params.toString();
}
